import { useState } from "react";

export const useGeneratePassword = () => {
    const [password, setPassword] = useState("");

    const fieldsArray = [
        {
            field: true,
            getChar: () => getRandomChar(65, 90),
        },
        {
            field: true,
            getChar: () => getRandomChar(97, 122),
        },
        {
            field: true,
            getChar: () => getRandomChar(48, 57),
        },
        {
            field: true,
            getChar: () => getSpecialChar(),
        },
    ];

    const getRandomPassword = () => {
        let generatedPassword = "";
        const checkedFields = fieldsArray.filter(({ field }) => field);

        for (let i = 0; i < 12; i++) {
            const index = Math.floor(Math.random() * checkedFields.length);
            const letter = checkedFields[index]?.getChar();

            if (letter) {
                generatedPassword += letter;
            }
        }

        if (generatedPassword) {
            setPassword(generatedPassword);
        }
    };

    return { newPassword: password, getNewPassword: getRandomPassword };
};

//utils fn
export function getRandomChar(min, max) {
    const limit = max - min + 1;
    return String.fromCharCode(Math.floor(Math.random() * limit) + min);
}

export function getSpecialChar() {
    const specialChar = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~'";
    return specialChar[Math.floor(Math.random() * specialChar.length)];
}
